import { createFileRoute, notFound } from "@tanstack/react-router";
import { TeamMembers } from "@/modules/profile/pages/team-members";
import { getUserOptions } from "creso-core/hooks";
import { shouldEnableRBAC } from "creso-core/utils";

function TeamMembersRouteGuard() {
  return <TeamMembers />;
}

export const Route = createFileRoute("/(auth)/_headed/account/team-members")({
  component: TeamMembersRouteGuard,
  loader: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(getUserOptions());
    const isRBACEnabled = user?.username ? shouldEnableRBAC(user) : false;
    if (!isRBACEnabled) {
      throw notFound({ routeId: "__root__" });
    }
  },
});
